'use client'

import { useAppContext } from '@context/AppContext';
import { useVisitor } from '@/app/visitor/useVisitor';

export default function Header() {
	const { context_data } = useAppContext();
	const visitor = useVisitor();

	const handleSignIn = async (e:any) => {
		e.preventDefault();
		visitor.openEntry();
	}

	const handleSignOut = async (e:any) => {
		e.preventDefault();
		await visitor.leave({ callbackUrl: context_data.origin[2] });
	}

	return (
		<header className={css_class.header}>
			<noscript><style>{`.nojs-show { opacity: 1; top: 0; }`}</style></noscript>
			<div className={`nojs-show ${css_class.loaded}`}>
				{!visitor.isPresent && (<>
					<a className={css_class.href_unsigned} onClick={handleSignIn}>Sign in</a>
				</>)}
				{visitor.isPresent && (<>
					{visitor.avatarUrl && (<span style={{ backgroundImage: `url('${visitor.avatarUrl}')` }} className={css_class.avatar}	/>)}
					<a className={css_class.href_signed} onClick={handleSignOut}>Sign out</a>
					{visitor.href ? (<> (<a href={visitor.href} className={css_class.href_signed}>{visitor.label}</a>)</>) : <> ({visitor.label})</>}
				</>)}
			</div>
		</header>
	)
}

const css_class = {
	header: "flex m-0 w-full justify-end min-h-[20px] pr-[30px]",
	// Former Header.module.css .loaded / .avatar, inlined 1:1.
	loaded: "relative top-0 opacity-100 p-0 m-0 transition-all duration-200 ease-in",
	avatar: "rounded-[2rem] float-left h-[2.8rem] w-[2.8rem] bg-white bg-cover bg-no-repeat",
	href_signed: "text-[14px] p-[5px] max-sm:py-2 mr-[0px] hover:underline cursor-pointer",
	href_unsigned: "text-[14px] p-[5px] max-sm:py-2 mr-[0px] hover:underline cursor-pointer",
	href_namekey: "text-[14px] p-[5px] max-sm:py-2 mr-[0px] hover:underline cursor-pointer",
}
